<form class="m-h-12 m-v-12">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreRecherche' | translate }}</h3>
  <mat-radio-group (change)="selectGdfSearchChoice($event)"
    class="mat-typography">
    <mat-radio-button value="dossierTerrain">{{ 'sigt.integration.rechercheGdf.tabs.dossierTerrain' | translate
      }}</mat-radio-button>
    <mat-radio-button value="droits">{{ 'sigt.integration.rechercheGdf.tabs.droits' | translate
      }}</mat-radio-button>
    <mat-radio-button value="transaction">{{ 'sigt.integration.rechercheGdf.tabs.transaction' | translate
      }}</mat-radio-button>
    <mat-radio-button value="intervenant">{{ 'sigt.integration.rechercheGdf.tabs.intervenant' | translate
      }}</mat-radio-button>
    <mat-radio-button value="avisPossession">{{ 'sigt.integration.rechercheGdf.tabs.avisPossession' | translate
      }}</mat-radio-button>
  </mat-radio-group>
</form>

<button style="display: none;"
  class="tour-interactif-step-0"
  (click)="gdfSearchChoice='dossierTerrain'"></button>
<button style="display: none;"
  class="tour-interactif-step-1"
  (click)="gdfSearchChoice='droits'"></button>
<button style="display: none;"
  class="tour-interactif-step-2"
  (click)="gdfSearchChoice='transaction'"></button>
<button style="display: none;"
  class="tour-interactif-step-3"
  (click)="gdfSearchChoice='intervenant'"></button>
<button style="display: none;"
  class="tour-interactif-step-4"
  (click)="gdfSearchChoice='avisPossession'"></button>

<div class="tour-interactif-sigt-recherche-gdf-container">
  <div id="typeRechercheNull"
    class="m-h-12 m-v-8"
    *ngIf="gdfSearchChoice === ''">
    <div class="container">
      <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>
      <div class="no-selection-guide">
        <mat-icon>question_exchange</mat-icon>
        <div>{{ 'sigt.integration.rechercheGdf.form.recherche.choisirTypeRecherche' | translate }}</div>
      </div>
    </div>
  </div>
  <app-dossier-terrain-gdf *ngIf="gdfSearchChoice === 'dossierTerrain'"></app-dossier-terrain-gdf>
  <app-droit-gdf *ngIf="gdfSearchChoice === 'droits'"></app-droit-gdf>
  <app-transaction-gdf *ngIf="gdfSearchChoice === 'transaction'"></app-transaction-gdf>
  <app-intervenant-gdf *ngIf="gdfSearchChoice === 'intervenant'"></app-intervenant-gdf>
  <app-avis-prise-prossession-gdf *ngIf="gdfSearchChoice === 'avisPossession'"></app-avis-prise-prossession-gdf>
</div>

<mat-divider></mat-divider>

<div class="m-h-12 m-v-8">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreListeResultats' | translate }}</h3>
  <div *ngIf="gdfResults !== null && gdfResults.length > 0">
    <button class="deleteBtn"
      mat-icon-button
      color="warn"
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="Supprimer"
      [disabled]="!selection.hasValue() || selection.length === 0"
      (click)="deleteResults()">
      <mat-icon>delete</mat-icon>
    </button>
    <mat-divider></mat-divider>
  </div>

  <table mat-table
    id="resultatsGDFTable"
    [dataSource]="resultatsTableDataSource">
    <ng-container matColumnDef="select">
      <th mat-header-cell
        *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell
        *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="nomCouche">
      <th mat-header-cell
        *matHeaderCellDef
        mat-sort-header></th>
      <td mat-cell
        *matCellDef="let row"> {{row.nomCouche}} </td>
    </ng-container>
    <ng-container matColumnDef="style">
      <th mat-header-cell
        *matHeaderCellDef></th>
      <td mat-cell
        *matCellDef="let row">
        <igo-style-modal-layer-button [layer]="row.layer"></igo-style-modal-layer-button>
      </td>
    </ng-container>
    <ng-container matColumnDef="grille">
      <th mat-header-cell
        *matHeaderCellDef></th>
      <td mat-cell
        *matCellDef="let row">
        <button mat-icon-button
          color="primary"
          aria-label="Ouvrir la grille de résultat de cette couche"
          (click)="ouvrirGrille(row)">
          <mat-icon>table</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="visibility">
      <th mat-header-cell
        *matHeaderCellDef></th>
      <td mat-cell
        *matCellDef="let row">
        <button mat-icon-button
          color="primary"
          aria-label="Afficher/cacher cette couche"
          (click)="showHideLayer(row)">
          <mat-icon>{{row.layer.visible ? 'visibility' : 'visibility_off'}}</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row
      *matHeaderRowDef="colonnesTableResultats"></tr>
    <tr mat-row
      *matRowDef="let row; columns: colonnesTableResultats"></tr>
  </table>

</div>